import React from "react";

export function parseWhatsAppContent(content) {
  let payload = content;
  if (typeof content === "string") {
    if (content.trim() === "[send_booking_flow sent]") {
      return { text: "Appointment booking form sent", actions: ["Book appointment"] };
    }
    try {
      payload = JSON.parse(content);
    } catch {
      return { text: content, actions: [] };
    }
  }
  if (typeof payload === "string") return { text: payload, actions: [] };
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return { text: String(content ?? ""), actions: [] };
  }

  const interactive = payload.interactive ?? payload;
  const type = interactive.message_type ?? interactive.type;
  const body = typeof interactive.body === "string" ? interactive.body : interactive.body?.text;
  const text = interactive.text ?? body;
  if (type === "buttons" || type === "button") {
    const buttons = interactive.buttons ?? interactive.action?.buttons ?? [];
    return { text: text ?? "", actions: buttons.map((button) => button.title ?? button.reply?.title).filter(Boolean) };
  }
  if (type === "list") {
    const sections = interactive.sections ?? interactive.action?.sections ?? [];
    return {
      text: text ?? "",
      actions: sections.flatMap((section) => (section.rows ?? []).map((row) => row.title ?? row.label).filter(Boolean)),
    };
  }
  if (type === "flow") {
    return {
      text: text ?? "Appointment booking form sent",
      actions: [interactive.action?.parameters?.flow_cta ?? "Open form"],
    };
  }
  if (payload.type === "text" && typeof payload.text?.body === "string") {
    return { text: payload.text.body, actions: [] };
  }
  return { text: typeof content === "string" ? content : JSON.stringify(content), actions: [] };
}

export default function WhatsAppMessageContent({ content }) {
  const { text, actions } = parseWhatsAppContent(content);
  return (
    <div>
      <div style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{text}</div>
      {actions.length > 0 && (
        <div aria-label="Message options" style={{ marginTop: 8, borderTop: "1px solid currentColor" }}>
          {actions.map((label, index) => (
            <div key={`${label}-${index}`} style={{ padding: "7px 4px", textAlign: "center", fontWeight: 600, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}